module.exports = __webpack_public_path__ + "img/twitter_blue.b11d8efc.svg";